/**
 * Base Monitor class to extend when adding custom monitors to the monitor plugin
 */
export class MonitorBase {
  constructor(game, parent, { label, value = '' } = {}) {
    this._parent = parent;
    this._game = game;
    this._container = document.createElement('div');
    this._container.style.display = 'flex';
    this._container.style.border = '1px solid rgba(255,255,255,0.5)';
    this._container.style.boxSizing = 'border-box';
    this._container.style.padding = '5px 10px';
    this._container.style.margin = '2px';
    this._container.style.flexShrink = '0';
    this._container.style.flexGrow = '1';
    this._container.style.justifyContent = 'inherit';
    this._label = document.createElement('p');
    this._label.style.marginRight = '10px';
    this._label.innerHTML = `${label.toUpperCase()} : `;
    this._value = value;
    this._valueLabel = document.createElement('p');
    this._container.appendChild(this._label);
    this._container.appendChild(this._valueLabel);
    this._parent.appendChild(this._container);
    this.setValue(value);
  }

  shutdown() {
    this._parent.removeChild(this._container);
  }

  get game() {
    return this._game;
  }

  /**
   * set the current value of this monitor
   * @param {*} value value of monitor
   */
  set value(value) {
    this.setValue(value);
  }

  /**
   * get the current value of this monitor
   */
  get value() {
    return this.getValue();
  }

  /**
   * set the current value of this monitor
   * @param {*} value value of monitor
   */
  setValue(value) {
    this._value = value;
    this._valueLabel.innerHTML = value;
  }

  /**
   * get the current value of this monitor
   */
  getValue() {
    return this._value;
  }

  /**
   * print a more detailed log of the monitor into the console
   */
  getLog() {
    return this._enabled ? this._valueLabel.innerHTML : 'disabled';
  }
}
